import { type RouterConfig, PAGE_TYPE } from '@/types/manifest';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'icon-preview',
    exclusiveRoutePath: '/icon-preview',
    getComponent: () => import('./IconPreview.vue'),
};

export const manifest = {
    ...(import.meta.env.DEV ? routerConfig : null),
    label: '图标预览',
    tabIndex: 999,
};
